import { forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ProfileBadge } from '../ProfileBadge';
import { Media } from './Media';
import type { MediaProps } from './interfaces';

const useStyles = makeStyles({ name: 'RoundedMedia' })((theme) => ({
  container: {
    position: 'relative',
  },
  media: {
    borderRadius: theme.radii.large,
    overflow: 'hidden',
  },
  gutterBottom: {
    marginBottom: theme.spacing(2),
  },
  adjustedMedia: {
    top: 1,
  },
}));

interface RoundedMediaProps extends MediaProps {
  readonly badgeId?: string;
  readonly isFeatured?: boolean;
  readonly gutterBottom?: boolean;
}

export const RoundedMedia = forwardRef<HTMLImageElement, RoundedMediaProps>(({
  badgeId, isFeatured, gutterBottom = true, ...restProps
}, ref) => {
  const { classes, cx } = useStyles();

  if (!badgeId && !isFeatured) {
    return (
      <Media
        className={cx(classes.media, gutterBottom && classes.gutterBottom)}
        ref={ref}
        {...restProps}
      />
    );
  }

  return (
    <div className={classes.container}>
      <Media
        className={cx(classes.media, classes.adjustedMedia, gutterBottom && classes.gutterBottom)}
        ref={ref}
        {...restProps}
      />

      <ProfileBadge
        badgeId={badgeId}
        isFeatured={isFeatured}
      />
    </div>
  );
});
